import { Bot } from 'lucide-react';
import { motion, useReducedMotion } from 'framer-motion';

import { useAiChat } from './useAiChat';

/** Floating launcher. */
export function AiLauncher() {
  const chat = useAiChat();
  const reduce = useReducedMotion();

  if (chat.open) return null;

  return (
    <motion.button
      type="button"
      data-ai-widget
      onClick={() => chat.openChat()}
      aria-label="Ask Recovry AI"
      initial={reduce ? false : { scale: 0.8, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ duration: reduce ? 0 : 0.2 }}
      className="fixed bottom-6 right-6 z-40 flex [.has-sticky-bar_&]:bottom-24 lg:[.has-sticky-bar_&]:bottom-6 size-14 items-center justify-center rounded-full bg-primary text-primary-foreground shadow-[0_6px_20px_rgba(15,110,86,0.3)] transition-transform hover:scale-105 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
    >
      <Bot className="size-6" />
    </motion.button>
  );
}
